import { Badge, Dropdown } from 'antd'
import List2 from 'components/kit/widgets/Lists/2'
import React from 'react'
import { useSelector } from 'react-redux'
import styles from './style.module.scss'

const Actions = () => {
  const orders = useSelector(state => state.orders.data)
  const notifyOrders = orders && orders.filter(order => order.orderType !== 'open')

  const menu = (
    <React.Fragment>
      <div className="card cui__utils__shadow width-350 border-0">
        <div className="card-body p-0">
          <List2 orders={notifyOrders} />
        </div>
      </div>
    </React.Fragment>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <div className={styles.dropdown}>
        <Badge count={notifyOrders && notifyOrders.length}>
          <i className={`${styles.icon} fe fe-bell`} />
        </Badge>
      </div>
    </Dropdown>
  )
}

export default Actions
